import React from 'react'
import { Row, Col } from 'react-bootstrap';
import Styles from './AccessoryPreviewCardLoader.module.scss'
import AccessoryPreviewCardSkeletonBody from '../AccessoryPreviewCardSkeletonBody/AccessoryPreviewCardSkeletonBody';

const AccessoryPreviewCardLoader = ({cards}:any) => {
    return (
        <div>
            <Row className={`justify-content-center ${Styles.cardsPadding}`}>
            {[...Array(cards)].map((index) => (
              <Col
                xl='4'
                lg='4'
                md='6'
                sm='6'
                xs='12'
                className={`${Styles.allCards} ${
                  ( index == 0) && Styles.cardsPreview
                }`}
              >
                  <AccessoryPreviewCardSkeletonBody />
              </Col>
            ))}
          </Row>
        </div>
    )
}

export default AccessoryPreviewCardLoader
